import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { fetchMe, fetchCsrfToken } from 'shared/api/sessionAuth';

type Role = 'member' | 'supporter' | 'manager';

type Props = {
  role: Role;
  children: React.ReactNode;
};

const AUTH_STATUS = {
  CHECKING: 'checking',
  OK: 'ok',
  NG: 'ng',
} as const;

const LOGIN_PATHS: Record<Role, string> = {
  member: '/login',
  supporter: '/supporter/login',
  manager: '/manager/login',
};

const RequireAuth: React.FC<Props> = ({ role, children }) => {
  const [auth, setAuth] = useState<typeof AUTH_STATUS[keyof typeof AUTH_STATUS]>(AUTH_STATUS.CHECKING);
  const location = useLocation();

  useEffect(() => {
    (async () => {
      try {
        await fetchCsrfToken(); // CSRFトークンを取得
        const me = await fetchMe();
        const roles: string[] = Array.isArray(me?.roles) ? me.roles : [];
        if (roles.includes(role)) {
          setAuth(AUTH_STATUS.OK);
        } else {
          setAuth(AUTH_STATUS.NG);
        }
      } catch {
        setAuth(AUTH_STATUS.NG);
      }
    })();
  }, [role]);

  if (auth === AUTH_STATUS.CHECKING) return <div>Loading...</div>;
  if (auth === AUTH_STATUS.NG) {
    return <Navigate to={LOGIN_PATHS[role]} state={{ from: location }} replace />;
  }
  return <>{children}</>;
};

export default RequireAuth;
